module.exports = __webpack_public_path__ + "static/media/camera_off.33114cd6.svg";